"use strict";var e=require("react");module.exports=function({controlled:t,default:r}){const{current:u}=e.useRef(void 0!==t),[c,o]=e.useState(r);return[u?t:c,e.useCallback((e=>{u||o(e)}),[])]};
//# sourceMappingURL=index.js.map
